import { API_BASE_URL } from '../config';

export const getImageUrl = (customer, event, imagePath) => {
  // Remove any leading slashes from the image path
  const cleanPath = imagePath.replace(/^\/+/, '');
  // Construct the folder path for the server endpoint
  const folderPath = `${customer}/${event}/${cleanPath}`;
  return `${API_BASE_URL}/folders/${folderPath}`;
};

/**
 * Calculate the scaled logo width based on actual image dimensions and display size
 * @param {Object} brandedContentSettings - The branded content settings object
 * @param {number} actualImageWidth - The natural width of the image in pixels
 * @param {number} displayWidth - The width of the displayed image in pixels
 * @param {number} minWidth - Minimum logo width in pixels (default: 20)
 * @returns {number} The scaled logo width in pixels
 */
export const getScaledLogoWidth = (brandedContentSettings, actualImageWidth, displayWidth, minWidth = 20) => {
  if (!brandedContentSettings || !brandedContentSettings.width || !actualImageWidth || !displayWidth) {
    return minWidth;
  }
  
  const scaleFactor = displayWidth / actualImageWidth;
  return Math.max(brandedContentSettings.width * scaleFactor, minWidth);
}; 